/*
  BALINARO — Cart drawer v2 custom JS.
  All custom cart-drawer behaviour lives here, NOT in theme.js,
  so theme.js stays untouched and saveable.

  Hooks into the parent theme's existing events:
    - cart:updated      (theme.CartForm dispatches after qty/note changes)
    - cart:build        (we dispatch to ask theme.CartForm to re-render)
    - cart:open         (theme.CartDrawer dispatches when drawer opens)
    - ajaxProduct:added (theme.AjaxProduct dispatches after add-to-cart)
*/

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Slide-cart neutralisation (paired with the early-head blocker in
     layout/theme.liquid). The blocker stops the script from loading and
     locks window.SLIDECART_* to open our drawer. This block adds the
     last line of defence: kill any leftover #slidecarthq DOM if it
     somehow appears, and redirect third-party ATC buttons.
  ------------------------------------------------------------------ */
  function openOurDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function killSlideCartDom() {
    var sel = '#slidecarthq, #slidecarthq-overlay, .slidecarthq-overlay';
    document.querySelectorAll(sel).forEach(function (el) { el.remove(); });
  }
  killSlideCartDom();
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          // SVG nodes have id as an SVGAnimatedString (not a string), so
          // guard with typeof checks before calling string methods.
          var nid = typeof n.id === 'string' ? n.id : '';
          var ncls = typeof n.className === 'string' ? n.className : '';
          if (nid === 'slidecarthq' || nid.indexOf('slidecarthq') === 0 || ncls.indexOf('slidecarthq') !== -1) {
            n.remove();
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* MutationObserver not supported, skip */ }

  // Third-party ATC buttons (Code Black Belt "also-bought", Qikify sticky bar)
  // used to invoke the slide cart. Capture-phase listener so we run first.
  document.addEventListener('click', function (e) {
    if (e.target.closest(
      '.cbb-also-bought-add-to-cart-button, button.qsc2-stickybar__action-btn'
    )) {
      setTimeout(openOurDrawer, 800);
    }
  }, true);

  var DEBUG = true;
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[cart-drawer-v2]'].concat([].slice.call(arguments))); }
  function warn() { if (DEBUG && window.console) console.warn.apply(console, ['[cart-drawer-v2]'].concat([].slice.call(arguments))); }

  log('script loaded');

  /* ------------------------------------------------------------------
     Tiny helper: fetch the live cart
  ------------------------------------------------------------------ */
  function getCart() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  /* ------------------------------------------------------------------
     Bundle-safe guard: neutralise any /cart/update.js MERGE call.

     A POST to /cart/update.js with an `updates` payload merges cart
     lines server-side. On Trevo bundle products the Cart Transform
     Function silently mutates that call and collapses the cart to a
     single item — the "count badge flips to 1" bug. Bundle lines must
     stay qty:1; duplicates are grouped only at the display layer.

     theme.js's legacy CartDedupVariants routine was removed, but this
     guard stays as a safety net: if a stale cached theme.js (or any
     app) fires such a merge, we intercept it and return the real,
     untouched cart instead — so the caller still resolves cleanly.
     Note-only /cart/update.js calls (no `updates` key) pass through.
  ------------------------------------------------------------------ */
  (function guardCartUpdate() {
    if (!window.fetch || window.fetch.__balinaroGuarded) return;
    var nativeFetch = window.fetch.bind(window);
    function guarded(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (/\/cart\/update(\.js)?(\?|$)/.test(url) && String(method).toUpperCase() === 'POST') {
        var body = init && init.body;
        var isMerge = false;
        try {
          var parsed = typeof body === 'string' ? JSON.parse(body) : body;
          isMerge = !!(parsed && parsed.updates);
        } catch (e) { /* non-JSON body — treat as not a merge */ }
        if (isMerge) {
          warn('blocked /cart/update.js merge (bundle-safe guard)', body);
          return getCart().then(function (cart) {
            return new Response(JSON.stringify(cart), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            });
          });
        }
      }
      return nativeFetch(input, init);
    }
    guarded.__balinaroGuarded = true;
    window.fetch = guarded;
    log('fetch guard installed (bundle-safe /cart/update.js)');
  })();

  /* ------------------------------------------------------------------
     Update the count badge in the drawer title
  ------------------------------------------------------------------ */
  function updateCountBadge(cart) {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    // realItemCount() excludes the shipping-protection line (see SP section).
    var n = realItemCount(cart);
    el.textContent = n;
    log('count badge ->', n);
  }

  /* ------------------------------------------------------------------
     Trigger the theme's drawer to re-render from the live cart
  ------------------------------------------------------------------ */
  function rebuildDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  /* ------------------------------------------------------------------
     Smart diff for the cart rebuild.

     Why: theme.CartForm.cartMarkup() wipes [data-products].innerHTML
     and re-inserts. Every rebuild creates fresh <img> + text nodes,
     which causes (a) the image flash and (b) Transtore re-translating
     newly-injected text (it skips already-translated nodes but doesn't
     remember that a *new* node with the same text was just translated).

     Strategy: parse the new markup, match items by data-key against
     what's already in the DOM, and only touch the parts that changed.
     For unchanged items the DOM nodes (including <img>) are left alone.
  ------------------------------------------------------------------ */
  /* Patch theme.QtySelector so grouped rows don't trigger Shopify cart updates
     from the theme's directly-bound button listeners — we handle them ourselves
     via /cart/add.js and /cart/change.js. Without this, every + click fires
     BOTH our add AND theme's qty-change, causing double-modifies. */
  function patchQtySelector() {
    if (!(window.theme && theme.QtySelector && theme.QtySelector.prototype)) {
      return setTimeout(patchQtySelector, 50);
    }
    if (theme.QtySelector.prototype._groupedPatched) return;
    theme.QtySelector.prototype._groupedPatched = true;

    var originalChange = theme.QtySelector.prototype._change;
    theme.QtySelector.prototype._change = function (qty) {
      // Suppress for ALL cart-drawer rows. Bundle items must never see
      // /cart/change.js with qty>1 because Shopify's Cart Transform splits
      // them into separate lines, which compounds with every click.
      if (this.wrapper && this.wrapper.closest && this.wrapper.closest('#CartDrawer')) {
        log('QtySelector._change suppressed in cart drawer');
        return;
      }
      return originalChange.call(this, qty);
    };
    log('QtySelector._change patched');
  }
  patchQtySelector();

  function patchCartForm() {
    if (!(window.theme && theme.CartForm && theme.CartForm.prototype)) {
      return setTimeout(patchCartForm, 50);
    }
    if (theme.CartForm.prototype._smartDiffPatched) return;
    theme.CartForm.prototype._smartDiffPatched = true;

    function updateItemInPlace(oldEl, newEl) {
      // Sync data attrs (drives our +/- handler). Must include data-key
      // and data-group-keys because Shopify mints new line keys whenever
      // the bundle Cart Transform merges/splits — the old keys would 404
      // if the user clicked - on the row right after.
      ['key', 'grouped', 'groupKey', 'groupKeys', 'groupLineCount', 'variantId'].forEach(function (k) {
        var attr = 'data-' + k.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); });
        var nv = newEl.getAttribute(attr);
        var ov = oldEl.getAttribute(attr);
        if (nv === null && ov !== null) oldEl.removeAttribute(attr);
        else if (nv !== ov) oldEl.setAttribute(attr, nv);
      });

      // Qty input value
      var newQty = newEl.querySelector('.js-qty__num');
      var oldQty = oldEl.querySelector('.js-qty__num');
      if (newQty && oldQty && oldQty.value !== newQty.value) oldQty.value = newQty.value;

      // Price column — only swap if the HTML actually differs. Class is
      // `.cart__item--prices` (plural); the old singular selector matched
      // nothing, so price totals never refreshed on a qty change.
      var newPriceCol = newEl.querySelector('.cart__item--prices');
      var oldPriceCol = oldEl.querySelector('.cart__item--prices');
      if (newPriceCol && oldPriceCol && newPriceCol.innerHTML !== oldPriceCol.innerHTML) {
        oldPriceCol.innerHTML = newPriceCol.innerHTML;
      }

      // Variants line — same approach
      var newVar = newEl.querySelector('.cart__item--variants');
      var oldVar = oldEl.querySelector('.cart__item--variants');
      if (newVar && oldVar && newVar.innerHTML !== oldVar.innerHTML) {
        oldVar.innerHTML = newVar.innerHTML;
      } else if (newVar && !oldVar) {
        var nameEl = oldEl.querySelector('.cart__item--name');
        if (nameEl) nameEl.appendChild(newVar);
      } else if (!newVar && oldVar) {
        oldVar.remove();
      }
    }

    theme.CartForm.prototype.cartMarkup = function (text) {
      var markup = this._parseProductHTML(text);
      var newWrap = markup.items; // <div class="cart__items">
      var count = parseInt(newWrap.dataset.count, 10) || 0;
      var subtotal = newWrap.dataset.cartSubtotal;
      var savings = newWrap.dataset.cartSavings;

      this.updateCartDiscounts(markup.discounts);
      this.updateSavings(savings);

      if (count > 0) this.wrapper.classList.remove('is-empty');
      else this.wrapper.classList.add('is-empty');
      this.updateCount(count);

      var existingWrap = this.products.querySelector('.cart__items');
      if (!existingWrap) {
        // First render or empty state — just append.
        this.products.innerHTML = '';
        this.products.append(newWrap);
      } else {
        // Mirror dataset attrs on the wrapper itself.
        ['count', 'cartSavings', 'cartSubtotal'].forEach(function (k) {
          var attr = 'data-' + k.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); });
          var v = newWrap.getAttribute(attr);
          if (v === null) existingWrap.removeAttribute(attr);
          else existingWrap.setAttribute(attr, v);
        });

        // Match by GROUP identity (variant_id + final_price), not line key.
        // Shopify mints new line keys whenever the bundle Cart Transform
        // merges/splits, so matching by .key causes rows to vanish and
        // reappear even though the visual group is unchanged.
        function rowKey(el) {
          return el.dataset.groupKey || el.dataset.key;
        }

        var newItems = {};
        var newKeys = [];
        newWrap.querySelectorAll('.cart__item').forEach(function (el) {
          var k = rowKey(el);
          newItems[k] = el;
          newKeys.push(k);
        });
        var existingItems = {};
        existingWrap.querySelectorAll('.cart__item').forEach(function (el) {
          existingItems[rowKey(el)] = el;
        });

        // Remove rows whose group is no longer in the cart
        Object.keys(existingItems).forEach(function (k) {
          if (!newItems[k]) existingItems[k].remove();
        });

        // Update or insert rows in the new cart order
        newKeys.forEach(function (k, idx) {
          var newEl = newItems[k];
          var oldEl = existingItems[k];
          if (oldEl) {
            updateItemInPlace(oldEl, newEl);
            if (existingWrap.children[idx] !== oldEl) {
              existingWrap.insertBefore(oldEl, existingWrap.children[idx] || null);
            }
          } else {
            existingWrap.insertBefore(newEl, existingWrap.children[idx] || null);
          }
        });
      }

      setSubtotalDisplay(subtotal);
      this.reInit();
      if (window.AOS) AOS.refreshHard();
      if (window.Shopify && Shopify.StorefrontExpressButtons) Shopify.StorefrontExpressButtons.initialize();
    };

    log('CartForm.cartMarkup patched for smart diff');
  }
  patchCartForm();

  /* ------------------------------------------------------------------
     Quantity +/- on display-grouped rows.
     Shopify keeps bundle lines as separate qty:1 items (enforced by
     a Cart Transform Function — proven via direct /cart/update.js
     calls that silently revert). We can't merge in Shopify, so we
     group at the *display* layer (cart.ajax.liquid) and re-implement
     +/- to add/remove underlying lines instead of changing qty.
  ------------------------------------------------------------------ */
  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function syncCartAfterChange() {
    return getCart().then(function (cart) {
      updateCountBadge(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      rebuildDrawer();
      return cart;
    });
  }

  // Capture-phase click handler — intercepts EVERY +/- inside the cart
  // drawer (bundle and non-bundle alike). The bundle Cart Transform makes
  // /cart/change.js qty>1 unsafe, so we always use /cart/add.js for + and
  // /cart/change.js qty=0 (remove a line) or qty-1 (decrement) for -.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty__adjust');
    if (!btn) return;
    var row = btn.closest('#CartDrawer .cart__item');
    if (!row) return;
    e.stopImmediatePropagation();
    e.preventDefault();

    var keysAttr = row.dataset.groupKeys || row.dataset.key || '';
    var keys = keysAttr.split(',').filter(Boolean);
    var variantId = parseInt(row.dataset.variantId, 10);
    var lineCount = parseInt(row.dataset.groupLineCount, 10) || 1;
    var qtyInput = row.querySelector('.js-qty__num');
    var currentDisplayQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var isPlus = btn.classList.contains('js-qty__adjust--plus');

    if (isPlus) {
      log('+', { variantId: variantId, lineCount: lineCount });
      getCart().then(function (cart) {
        log('+ pre-add cart:', { item_count: cart.item_count, lines: cart.items.length });
        var sample = (cart.items || []).find(function (i) { return i.variant_id === variantId; });
        var props = sample && sample.properties ? sample.properties : null;
        var hasProps = props && Object.keys(props).length > 0;
        var payload = { id: variantId, quantity: 1 };
        if (hasProps) payload.properties = props;
        log('+ POST /cart/add.js payload:', payload);
        return postCart('/cart/add.js', payload);
      }).then(function (resp) {
        log('+ /cart/add.js response:', resp);
        if (resp && resp.status) warn('+ /cart/add.js errored:', resp);
        return syncCartAfterChange();
      }).then(reconcileProtection).catch(function (err) {
        warn('+ chain error:', err);
      });
    } else {
      if (lineCount > 1) {
        var keyToRemove = keys[keys.length - 1];
        log('- (grouped, removing last key)', { keyToRemove: keyToRemove });
        postCart('/cart/change.js', { id: keyToRemove, quantity: 0 })
          .then(function (r) { log('- /cart/change.js response:', r); return syncCartAfterChange(); })
          .then(reconcileProtection)
          .catch(function (err) { warn('- chain error:', err); });
      } else {
        var singleKey = keys[0] || row.dataset.key;
        var newQty = Math.max(0, currentDisplayQty - 1);
        log('- (single line)', { key: singleKey, newQty: newQty });
        postCart('/cart/change.js', { id: singleKey, quantity: newQty })
          .then(function (r) { log('- /cart/change.js response:', r); return syncCartAfterChange(); })
          .then(reconcileProtection)
          .catch(function (err) { warn('- chain error:', err); });
      }
    }
  }, true);

  /* ------------------------------------------------------------------
     Free-shipping bar — €150 threshold, red→green flip
  ------------------------------------------------------------------ */
  function formatMoney(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  function totalExcludingShippingProtection(cart) {
    if (!cart) return 0;
    var t = cart.total_price || 0;
    var line = spLine(cart);
    if (line) {
      var lp = (line.final_line_price != null) ? line.final_line_price
             : (line.line_price != null) ? line.line_price
             : (line.original_line_price || 0);
      t -= lp;
    }
    return t;
  }
  var spLastFsKey = null;
  function updateFreeShipping(cart) {
    var bar = document.querySelector('[data-free-shipping]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (!threshold) return;
    var total = totalExcludingShippingProtection(cart);
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, (total * 100) / threshold);
    var fill = bar.querySelector('.cart__free-shipping-fill');
    var textEl = bar.querySelector('[data-fs-text]');
    if (fill) fill.style.width = pct + '%';
    // Only touch the text when it actually changes. Rewriting it wipes
    // Transtore's converted money and causes an EUR flash — and a
    // protection toggle never changes `remaining`, so the bar stays put.
    var key = remaining + '|' + (remaining === 0 ? 1 : 0);
    if (key === spLastFsKey) return;
    spLastFsKey = key;
    if (remaining === 0) {
      bar.classList.add('is-unlocked');
      if (textEl) textEl.innerHTML = '<strong>FREE</strong> Shipping applied!';
    } else {
      bar.classList.remove('is-unlocked');
      if (textEl) textEl.innerHTML = 'Only <span class="trans-money" data-ts-value="' + (remaining / 100) + '">' + formatMoney(remaining) + '</span> away from <strong>Free Shipping</strong>';
    }
    retranslate();
  }

  /* ------------------------------------------------------------------
     Shipping-protection toggle.

     A real product (set in Theme settings → Cart) is added to the cart
     as an opt-out line. The toggle row lives in the footer; this code
     keeps the line and the toggle in sync with the live cart and
     persists the shopper's choice in a hidden cart attribute.

     /cart/change.js needs the line-item KEY (string "<variantId>:<hex>")
     as `id` — a bare variant-id number is rejected HTTP 400. Removal
     always resolves the key first.

     Speed: a protection toggle only ever moves the subtotal, so we
     update it OPTIMISTICALLY the instant the toggle is clicked (±the
     protection price) and skip the full drawer rebuild entirely. The
     real cart total then corrects the figure once the API calls land.
  ------------------------------------------------------------------ */
  var SP_ATTR = '_shipping-protection'; // hidden cart attribute (opt in/out)
  var spBusy = false;                   // re-entrancy guard
  var spLastTotal = null;               // last known cart.total_price (cents)

  function spEl() { return document.querySelector('[data-shipping-protection]'); }
  function spVariantId() {
    var el = spEl();
    return el ? parseInt(el.dataset.spVariantId, 10) || 0 : 0;
  }
  function spPrice() {
    var el = spEl();
    return el ? parseInt(el.dataset.spPrice, 10) || 0 : 0;
  }
  function spDefaultOn() {
    var el = spEl();
    return !!el && el.dataset.spDefaultOn === 'true';
  }
  // Every cart line for the protection variant (normally 0 or 1).
  function spLines(cart) {
    var vid = spVariantId(), out = [];
    if (!vid || !cart || !cart.items) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === vid) out.push(cart.items[i]);
    }
    return out;
  }
  function spLine(cart) { return spLines(cart)[0] || null; }
  // Sum of line quantities EXCLUDING the protection line.
  function realItemCount(cart) {
    if (!cart || !cart.items) return 0;
    var vid = spVariantId(), n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id !== vid) n += cart.items[i].quantity;
    }
    return n;
  }
  function setToggleUI(on) {
    var el = spEl();
    if (!el) return;
    var btn = el.querySelector('[data-sp-toggle]');
    if (btn) btn.setAttribute('aria-checked', on ? 'true' : 'false');
  }
  // Prod Transtore (the language/currency app) to re-convert money we just
  // wrote, so it doesn't sit in EUR for a beat before flipping to the local
  // currency. No-op when Transtore isn't present (default-locale visitors).
  function retranslate() {
    try {
      if (window._transtore && typeof window._transtore.reTranslate === 'function') {
        window._transtore.reTranslate();
      }
    } catch (e) { /* ignore */ }
  }
  // Write a cents value into the drawer subtotal. Skips the DOM write when
  // the value is unchanged — rewriting it would wipe Transtore's converted
  // markup and cause a needless EUR→local-currency flash.
  var spLastSubtotalCents = null;
  function setSubtotalDisplay(cents) {
    cents = parseInt(cents, 10);
    if (isNaN(cents) || cents === spLastSubtotalCents) return;
    var el = document.querySelector('[data-subtotal]');
    if (!el) return;
    spLastSubtotalCents = cents;
    el.innerHTML = formatMoney(cents);
    retranslate();
  }
  // Refresh the lightweight bits a protection change can touch (no rebuild).
  function applyCartTotals(cart) {
    if (!cart) return cart;
    spLastTotal = cart.total_price;
    setSubtotalDisplay(cart.total_price);
    updateCountBadge(cart);
    updateFreeShipping(cart);
    return cart;
  }

  // Remove EVERY protection line. change.js needs the line KEY (string)
  // and returns the updated cart, so we recurse on its response.
  function spPurge() {
    return getCart().then(function step(cart) {
      var lines = spLines(cart);
      if (!lines.length) return cart;
      return postCart('/cart/change.js', { id: lines[0].key, quantity: 0 }).then(step);
    });
  }
  // Guarantee exactly one protection line at qty 1; resolves to the cart.
  function spEnsureOne() {
    return getCart().then(function (cart) {
      var lines = spLines(cart);
      if (lines.length === 1 && lines[0].quantity === 1) return cart;
      if (lines.length === 0) {
        return postCart('/cart/add.js', { id: spVariantId(), quantity: 1 }).then(getCart);
      }
      return spPurge()
        .then(function () { return postCart('/cart/add.js', { id: spVariantId(), quantity: 1 }); })
        .then(getCart);
    });
  }

  // Reconcile the protection line with the desired state. Idempotent —
  // only calls the cart API when something is genuinely wrong.
  function reconcileProtection(cartArg) {
    if (!spEl() || !spVariantId() || spBusy) return Promise.resolve(cartArg);
    var p = cartArg ? Promise.resolve(cartArg) : getCart();
    return p.then(function (cart) {
      var attr = (cart.attributes && cart.attributes[SP_ATTR]) || '';
      var hasReal = realItemCount(cart) > 0;
      var lines = spLines(cart);
      var qty = lines.reduce(function (n, i) { return n + i.quantity; }, 0);
      var wantOn = hasReal && attr !== 'declined' && (attr === 'accepted' || spDefaultOn());

      if (wantOn && qty !== 1) {
        spBusy = true;
        setToggleUI(true);
        if (qty === 0 && spLastTotal != null) setSubtotalDisplay(spLastTotal + spPrice());
        log('protection: auto-adding');
        return spEnsureOne().then(function (c) { spBusy = false; return applyCartTotals(c); });
      }
      if (!wantOn && lines.length) {
        spBusy = true;
        setToggleUI(false);
        if (spLastTotal != null) setSubtotalDisplay(spLastTotal - spPrice());
        log('protection: removing (declined or empty cart)');
        return spPurge().then(function (c) { spBusy = false; return applyCartTotals(c); });
      }
      setToggleUI(lines.length > 0);
      spLastTotal = cart.total_price;
      return cart;
    }).catch(function (e) { spBusy = false; warn('protection reconcile failed', e); return cartArg; });
  }

  // Toggle click — optimistic subtotal first, then sync the cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-toggle]');
    if (!btn) return;
    e.preventDefault();
    if (spBusy || !spVariantId()) return;
    var turningOn = btn.getAttribute('aria-checked') !== 'true';
    spBusy = true;
    setToggleUI(turningOn);                                   // instant
    if (spLastTotal != null) {                                // instant subtotal
      setSubtotalDisplay(spLastTotal + (turningOn ? spPrice() : -spPrice()));
    }
    log('protection: toggled', turningOn ? 'ON' : 'OFF');
    var attrs = {};
    attrs[SP_ATTR] = turningOn ? 'accepted' : 'declined';
    postCart('/cart/update.js', { attributes: attrs })
      .then(function () { return turningOn ? spEnsureOne() : spPurge(); })
      .then(function (cart) {
        applyCartTotals(cart);
        setToggleUI(spLines(cart).length > 0);
        spBusy = false;
      })
      .catch(function (err) {
        spBusy = false; warn('protection toggle failed', err); refreshAll();
      });
  });

  /* ------------------------------------------------------------------
     Refresh everything from the live cart
  ------------------------------------------------------------------ */
  function refreshAll() {
    return getCart().then(function (cart) {
      spLastTotal = cart.total_price;
      updateCountBadge(cart);
      updateFreeShipping(cart);
      return reconcileProtection(cart);
    });
  }

  /* ------------------------------------------------------------------
     Upsell size-picker popup.

     ADD on an upsell card (snippets/cart-upsell.liquid) opens this popup
     to choose a size, then adds the chosen variant via /cart/add.js and
     rebuilds the drawer. The [data-upsell-modal] skeleton lives in
     cart-drawer.liquid; here we fill it from /products/<handle>.js.
  ------------------------------------------------------------------ */
  function upsellModalEl() { return document.querySelector('[data-upsell-modal]'); }

  function closeUpsellModal() {
    var m = upsellModalEl();
    if (m) m.setAttribute('hidden', '');
  }

  function openUpsellModal(handle) {
    var m = upsellModalEl();
    if (!m || !handle) return;
    fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (!product || !product.variants) return;
        var img = m.querySelector('[data-upsell-img]');
        if (img) { img.src = product.featured_image || ''; img.alt = product.title || ''; }

        var titleEl = m.querySelector('[data-upsell-title]');
        if (titleEl) titleEl.textContent = product.title || '';

        var priceEl = m.querySelector('[data-upsell-price]');
        if (priceEl) {
          var onSale = product.compare_at_price && product.compare_at_price > product.price;
          priceEl.innerHTML = onSale
            ? '<span class="cart__upsell-modal__price--was">' + formatMoney(product.compare_at_price) + '</span>' +
              '<span class="cart__upsell-modal__price--sale">' + formatMoney(product.price) + '</span>'
            : '<span>' + formatMoney(product.price) + '</span>';
        }

        var sel = m.querySelector('[data-upsell-select]');
        if (sel) {
          sel.innerHTML = '';
          var firstAvail = null;
          product.variants.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.available ? v.title : v.title + ' — sold out';
            opt.disabled = !v.available;
            sel.appendChild(opt);
            if (!firstAvail && v.available) firstAvail = v;
          });
          if (firstAvail) sel.value = firstAvail.id;
        }

        m.removeAttribute('hidden');
        retranslate();
        log('upsell modal opened:', handle);
      })
      .catch(function (e) { warn('upsell: product fetch failed', e); });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) {
      e.preventDefault();
      openUpsellModal(addBtn.getAttribute('data-product-handle'));
      return;
    }
    if (e.target.closest('[data-upsell-close]')) {
      closeUpsellModal();
      return;
    }
    var confirmBtn = e.target.closest('[data-upsell-confirm]');
    if (confirmBtn) {
      e.preventDefault();
      var m = upsellModalEl();
      var sel = m && m.querySelector('[data-upsell-select]');
      var variantId = sel ? parseInt(sel.value, 10) : 0;
      if (!variantId) return;
      confirmBtn.disabled = true;
      log('upsell add variant:', variantId);
      postCart('/cart/add.js', { id: variantId, quantity: 1 })
        .then(function (resp) {
          if (resp && resp.status) warn('upsell add errored:', resp);
          closeUpsellModal();
          return syncCartAfterChange();
        })
        .then(reconcileProtection)
        .catch(function (err) { warn('upsell add failed', err); })
        .then(function () { confirmBtn.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeUpsellModal();
  });

  /* ------------------------------------------------------------------
     Upsell slider — top-right ‹ › arrows + mouse-drag scrolling.
     (Touch swipe is handled natively by the track's overflow-x.)
  ------------------------------------------------------------------ */
  function upsellTrackOf(node) {
    var section = node.closest('[data-cart-upsell]');
    return section ? section.querySelector('.cart__upsell-track') : null;
  }
  function upsellSliderStep(track) {
    var card = track.querySelector('.cart__upsell-card');
    var gap = parseFloat(getComputedStyle(track).gap) || 14;
    return card ? (card.offsetWidth + gap) * 2 : track.clientWidth;
  }
  function syncUpsellArrows(track) {
    var section = track.closest('[data-cart-upsell]');
    if (!section) return;
    var nav = section.querySelector('[data-upsell-nav]');
    var prev = section.querySelector('[data-upsell-prev]');
    var next = section.querySelector('[data-upsell-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;
    if (nav) nav.hidden = maxScroll <= 1;          // nothing to scroll — hide nav
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
  }
  // Click-and-drag to scroll (mouse only — touch uses native scrolling).
  function initUpsellDrag(track) {
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.pageX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    document.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    document.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
    });
    // A drag must not also register as a click (which would open a popup).
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }
  function initUpsellSliders() {
    document.querySelectorAll('.cart__upsell-track').forEach(function (track) {
      if (!track.__upsellWired) {
        track.__upsellWired = true;
        track.addEventListener('scroll', function () { syncUpsellArrows(track); });
        initUpsellDrag(track);
        // Re-sync whenever the track's box changes size. Without this, the
        // first sync happens before the cart drawer has finished sliding in,
        // so clientWidth is 0 → arrows get hidden and only re-appear once
        // the user interacts (which fires a scroll event).
        if (window.ResizeObserver) {
          new ResizeObserver(function () { syncUpsellArrows(track); }).observe(track);
        }
      }
      syncUpsellArrows(track);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (!btn) return;
    var track = upsellTrackOf(btn);
    if (!track) return;
    var dir = btn.hasAttribute('data-upsell-prev') ? -1 : 1;
    track.scrollBy({ left: dir * upsellSliderStep(track), behavior: 'smooth' });
  });

  /* ------------------------------------------------------------------
     Wire up events
  ------------------------------------------------------------------ */
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart) { spLastTotal = cart.total_price; updateCountBadge(cart); updateFreeShipping(cart); }
    else { refreshAll(); }
  });
  document.addEventListener('ajaxProduct:added', function () {
    log('ajaxProduct:added');
    refreshAll();
  });
  document.addEventListener('cart:open', function () {
    log('cart:open');
    refreshAll();
    initUpsellSliders();
  });
  document.addEventListener('DOMContentLoaded', function () {
    log('DOMContentLoaded');
    refreshAll();
    initUpsellSliders();
  });
})();